const map = {
	"./AD.svg": 54392,
	"./AE.svg": 58633,
	"./AF.svg": 74170,
	"./AG.svg": 5131,
	"./AI.svg": 77197,
	"./AL.svg": 91392,
	"./AM.svg": 27345,
	"./AO.svg": 12147,
	"./AR.svg": 58070,
	"./AS.svg": 21895,
	"./AT.svg": 49064,
	"./AU.svg": 14457,
	"./AW.svg": 83451,
	"./AX.svg": 36636,
	"./AZ.svg": 71934,
	"./BA.svg": 81804,
	"./BB.svg": 53503,
	"./BD.svg": 57745,
	"./BE.svg": 94944,
	"./BF.svg": 65843,
	"./BG.svg": 3202,
	"./BH.svg": 82021,
	"./BI.svg": 27300,
	"./BJ.svg": 70423,
	"./BL.svg": 85481,
	"./BM.svg": 50616,
	"./BN.svg": 89451,
	"./BO.svg": 70394,
	"./BR.svg": 11887,
	"./BS.svg": 32958,
	"./BT.svg": 58241,
	"./BW.svg": 53202,
	"./BY.svg": 51060,
	"./BZ.svg": 22567,
	"./CA.svg": 84835,
	"./CC.svg": 86561,
	"./CD.svg": 69182,
	"./CF.svg": 3260,
	"./CG.svg": 15453,
	"./CH.svg": 36682,
	"./CI.svg": 89147,
	"./CK.svg": 85977,
	"./CL.svg": 29142,
	"./CM.svg": 76007,
	"./CN.svg": 27796,
	"./CO.svg": 49429,
	"./CR.svg": 88032,
	"./CU.svg": 89151,
	"./CV.svg": 26476,
	"./CW.svg": 57485,
	"./CX.svg": 59482,
	"./CY.svg": 37003,
	"./CZ.svg": 78936,
	"./DE.svg": 90206,
	"./DJ.svg": 67929,
	"./DK.svg": 60008,
	"./DM.svg": 92694,
	"./DO.svg": 8308,
	"./DZ.svg": 42729,
	"./EC.svg": 75507,
	"./EE.svg": 71181,
	"./EG.svg": 63167,
	"./ER.svg": 62866,
	"./ES.svg": 803,
	"./ET.svg": 42524,
	"./FI.svg": 48912,
	"./FJ.svg": 15011,
	"./FK.svg": 81970,
	"./FM.svg": 87356,
	"./FO.svg": 3806,
	"./FR.svg": 94923,
	"./GA.svg": 95039,
	"./GB.svg": 32364,
	"./GD.svg": 58530,
	"./GE.svg": 72755,
	"./GG.svg": 38929,
	"./GH.svg": 40774,
	"./GI.svg": 87223,
	"./GL.svg": 42074,
	"./GM.svg": 47339,
	"./GN.svg": 8504,
	"./GQ.svg": 18799,
	"./GR.svg": 39772,
	"./GT.svg": 34386,
	"./GU.svg": 67427,
	"./GW.svg": 16129,
	"./HK.svg": 18132,
	"./HN.svg": 76313,
	"./HR.svg": 47821,
	"./HT.svg": 23027,
	"./HU.svg": 35650,
	"./ID.svg": 30784,
	"./IE.svg": 28817,
	"./IL.svg": 21688,
	"./IM.svg": 47049,
	"./IN.svg": 2234,
	"./IO.svg": 79755,
	"./IQ.svg": 74557,
	"./IR.svg": 11934,
	"./IS.svg": 48335,
	"./IT.svg": 38192,
	"./JE.svg": 40680,
	"./JM.svg": 83920,
	"./JP.svg": 19941,
	"./KE.svg": 60759,
	"./KG.svg": 72357,
	"./KH.svg": 93538,
	"./KI.svg": 56179,
	"./KM.svg": 43839,
	"./KN.svg": 72140,
	"./KP.svg": 56618,
	"./KR.svg": 93096,
	"./KW.svg": 67029,
	"./KY.svg": 81475,
	"./KZ.svg": 36336,
	"./LA.svg": 32410,
	"./LB.svg": 57993,
	"./LC.svg": 98840,
	"./LI.svg": 48866,
	"./LK.svg": 72352,
	"./LR.svg": 16377,
	"./LS.svg": 50984,
	"./LT.svg": 72231,
	"./LU.svg": 32694,
	"./LV.svg": 45653,
	"./LY.svg": 24722,
	"./MA.svg": 58265,
	"./MC.svg": 31707,
	"./MD.svg": 98644,
	"./ME.svg": 24277,
	"./MG.svg": 70151,
	"./MH.svg": 93584,
	"./MK.svg": 38723,
	"./ML.svg": 80444,
	"./MM.svg": 34717,
	"./MN.svg": 80542,
	"./MO.svg": 59471,
	"./MP.svg": 98200,
	"./MQ.svg": 33065,
	"./MR.svg": 17978,
	"./MS.svg": 37035,
	"./MT.svg": 74884,
	"./MU.svg": 29605,
	"./MV.svg": 30470,
	"./MW.svg": 18007,
	"./MX.svg": 42528,
	"./MY.svg": 5329,
	"./MZ.svg": 50786,
	"./NA.svg": 40112,
	"./NE.svg": 26972,
	"./NF.svg": 5999,
	"./NG.svg": 62270,
	"./NI.svg": 39400,
	"./NL.svg": 36629,
	"./NO.svg": 48406,
	"./NP.svg": 17681,
	"./NR.svg": 2483,
	"./NU.svg": 68588,
	"./NZ.svg": 95467,
	"./OM.svg": 5347,
	"./PA.svg": 63558,
	"./PE.svg": 51066,
	"./PF.svg": 66153,
	"./PG.svg": 31288,
	"./PH.svg": 34175,
	"./PK.svg": 62476,
	"./PL.svg": 46515,
	"./PR.svg": 57365,
	"./PS.svg": 31732,
	"./PT.svg": 64795,
	"./PW.svg": 83432,
	"./PY.svg": 13630,
	"./QA.svg": 30101,
	"./RO.svg": 71050,
	"./RS.svg": 28110,
	"./RU.svg": 53024,
	"./RW.svg": 29538,
	"./SA.svg": 96179,
	"./SB.svg": 5440,
	"./SC.svg": 62353,
	"./SD.svg": 80526,
	"./SE.svg": 18463,
	"./SG.svg": 91245,
	"./SI.svg": 70763,
	"./SK.svg": 91081,
	"./SL.svg": 41817,
	"./SM.svg": 26999,
	"./SN.svg": 22404,
	"./SO.svg": 421,
	"./SR.svg": 2371,
	"./SS.svg": 39553,
	"./ST.svg": 79646,
	"./SV.svg": 63196,
	"./SX.svg": 23466,
	"./SY.svg": 65435,
	"./SZ.svg": 84072,
	"./TC.svg": 24480,
	"./TD.svg": 90367,
	"./TG.svg": 11340,
	"./TH.svg": 38219,
	"./TJ.svg": 91721,
	"./TK.svg": 87480,
	"./TM.svg": 62278,
	"./TN.svg": 84709,
	"./TO.svg": 33540,
	"./TR.svg": 18401,
	"./TT.svg": 48751,
	"./TV.svg": 59197,
	"./TW.svg": 69724,
	"./TZ.svg": 47545,
	"./UA.svg": 96801,
	"./UG.svg": 99471,
	"./US.svg": 53427,
	"./UY.svg": 48329,
	"./UZ.svg": 22746,
	"./VA.svg": 12024,
	"./VC.svg": 92570,
	"./VE.svg": 2500,
	"./VG.svg": 67974,
	"./VI.svg": 21120,
	"./VN.svg": 22239,
	"./VU.svg": 60884,
	"./WS.svg": 57869,
	"./XK.svg": 12740,
	"./YE.svg": 29249,
	"./ZA.svg": 14212,
	"./ZM.svg": 5152,
	"./ZW.svg": 36842
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 86722;